"use client";

import { useState, useEffect, createContext, useContext } from "react";
import http from "@/libs/config/http";
import { useSession } from "./useSession";

const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const { session } = useSession();

  useEffect(() => {
    if (!session) return;

    const fetchWishlist = async () => {
      try {
        const res = await http("account/wishlist", {
          headers: {
            Authorization: `Bearer ${session}`,
          },
        });
        if (res.success) {
          setWishlistItems(res.data);
        }
      } catch (err) {
        console.error("Wishlist fetch error", err);
      }
    };

    fetchWishlist();
  }, [session]);

  const addToWishlist = async (product_id) => {
    try {
      const res = await http("account/addWishList", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${session}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ product_id }),
      });

      if (res.success) {
        setWishlistItems((prev) => [...prev, { id: product_id }]);
      }
    } catch (err) {
      console.error("Add to wishlist error", err);
    }
  };

  const removeFromWishlist = (product_id) => {
    setWishlistItems((prev) => prev.filter((item) => item.id !== product_id));
  };

  const isWished = (product_id) =>
    wishlistItems.some((item) => item.id === product_id);

  return (
    <WishlistContext.Provider
      value={{ wishlistItems, addToWishlist, removeFromWishlist, isWished }}
    >
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
